export default {
    change: 'เปลี่ยน'
}
